import React, { useState, useRef, useEffect } from 'react';
import ColorsList from './ColorsList';
import ViewColor from './ViewColor';
import { useTranslation } from 'react-i18next';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './Users.css';

// Colors management with master-detail view
const Colors = () => {
  const { t } = useTranslation('admin');
  const [selectedColorId, setSelectedColorId] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // Start with 'list' like Users
  const listRef = useRef();
  const viewRef = useRef();

  useEffect(() => {
    updateToolbar(viewMode);
  }, [viewMode, t]);

  const updateToolbar = (mode) => {
    let toolbar = null;

    if (mode === 'list') {
      // List view
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleNew}>
            <span className="icon">+</span> {t('common:ui.new')}
          </button>
          <button className="toolbar-btn" onClick={handleRefresh}>
            <span className="icon">&#x21bb;</span> {t('common:ui.refresh')}
          </button>
        </>
      );
    } else if (mode === 'create') {
      // Create mode
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">&#x1F4BE;</span> {t('common:ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">&#x2716;</span> {t('common:ui.cancel')}
          </button>
        </>
      );
    } else if (mode === 'edit') {
      // Edit mode
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">&#x1F4BE;</span> {t('common:ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">&#x2716;</span> {t('common:ui.cancel')}
          </button>
        </>
      );
    } else {
      // View mode
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleEdit}>
            <span className="icon">&#x270F;&#xFE0F;</span> {t('common:ui.edit')}
          </button>
          <button className="toolbar-btn danger" onClick={handleDelete}>
            <span className="icon">&#x1F5D1;&#xFE0F;</span> {t('common:ui.delete')}
          </button>
          <button className="toolbar-btn" onClick={handleBack}>
            <span className="icon">&#x2B05;&#xFE0F;</span> {t('common:ui.back')}
          </button>
        </>
      );
    }

    if (window.setColorsToolbar) {
      window.setColorsToolbar(toolbar);
    }
  };

  const handleSelectColor = (colorId) => {
    setSelectedColorId(colorId);
    setViewMode('view');
  };

  const handleBack = () => {
    setSelectedColorId(null);
    setViewMode('list');
  };

  const handleNew = () => {
    setSelectedColorId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedColorId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleSave = () => {
    if (viewRef.current) {
      viewRef.current.handleSave();
    }
  };

  const handleDelete = () => {
    if (viewRef.current) {
      viewRef.current.handleDelete();
    }
  };

  const handleRefresh = () => {
    if (listRef.current) {
      listRef.current.fetchColors();
    }
  };

  const handleColorCreated = (colorId) => {
    setSelectedColorId(colorId);
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchColors();
    }
  };

  const handleSaveComplete = () => {
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchColors();
    }
  };

  return (
    <div className="departments-page">
      <ResizablePanels
        leftPanel={
          <ColorsList
            ref={listRef}
            onSelectColor={handleSelectColor}
            selectedColorId={selectedColorId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewColor
              ref={viewRef}
              colorId={selectedColorId}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onBack={handleBack}
              onEdit={handleEdit}
              onSave={handleSaveComplete}
              onCancel={handleCancel}
              onColorCreated={handleColorCreated}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
};

export default Colors;
